// Shared editorial-readiness helpers for Candidate Stories triage.
export const READINESS = [
  { key: "READY FOR DRAFT", label: "Ready for Draft", color: "bg-emerald/15 text-emerald border-emerald", rank: 1 },
  { key: "NEEDS MORE RESEARCH", label: "Needs More Research", color: "bg-amber/15 text-amber border-amber", rank: 2 },
  { key: "SINGLE-SOURCE — HUMAN REVIEW", label: "Single-Source", short: "SINGLE-SOURCE", color: "bg-amber/15 text-amber border-amber", rank: 3 },
  { key: "CONFLICTING SOURCES — HUMAN REVIEW", label: "Conflicting Sources", short: "CONFLICTING", color: "bg-crimson/15 text-crimson border-crimson", rank: 4 },
  { key: "DO NOT PUBLISH", label: "Do Not Publish", color: "bg-crimson/25 text-crimson border-crimson", rank: 5 },
];

export function readinessOf(c) {
  return (c && c.research && c.research.recommended_action) || null;
}

export function readinessMeta(action) {
  return READINESS.find((r) => r.key === action) || null;
}

export function readinessRank(c) {
  const m = readinessMeta(readinessOf(c));
  return m ? m.rank : 99;
}

// Draft-safety policy per readiness action.
export function draftPolicy(action, unverified = 0) {
  switch (action) {
    case "READY FOR DRAFT": return { mode: "ok" };
    case "NEEDS MORE RESEARCH": return { mode: "warn", msg: "Research recommends NEEDS MORE RESEARCH. Consider ‘Research Further Again’ before drafting. Create a draft anyway?" };
    case "SINGLE-SOURCE — HUMAN REVIEW": return { mode: "confirm", msg: "This is a SINGLE-SOURCE story. Explicit human confirmation is required. Unverified claims must NOT be presented as fact. Create a draft for human editing?" };
    case "CONFLICTING SOURCES — HUMAN REVIEW": return { mode: "confirm", msg: "Sources CONFLICT on this story. Explicit human confirmation is required. Create a draft for human editing?" };
    case "DO NOT PUBLISH": return { mode: "blocked", msg: "Research flagged this story ‘DO NOT PUBLISH’. Draft creation is disabled. Use ‘Override Editorial Warning’ to proceed." };
    default:
      return unverified > 0
        ? { mode: "confirm", msg: `${unverified} claim(s) remain UNVERIFIED. Unverified claims must NOT be presented as fact. Create a draft anyway?` }
        : { mode: "ok" };
  }
}
